/**
 * Client-side instrumentation for Next.js
 *
 * This file runs before React hydration, allowing us to initialize
 * Application Insights early and capture errors that occur during hydration.
 *
 * See: https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client
 */

import {getClientConfig} from './app/config/clientConfig';
import {initializeAppInsights} from './lib/appInsights';

// Initialize Application Insights early if connection string is available
// This allows us to capture early errors and hydration issues
if (typeof window !== 'undefined') {
    const { applicationInsightsConnectionString } = getClientConfig();

    if (applicationInsightsConnectionString) {
        console.log('Application Insights: Initializing');
        initializeAppInsights(applicationInsightsConnectionString);
    } else {
        console.log('Application Insights: No connection string.');
    }
}
